
import { defineComponent } from 'vue'
import { WeveNavigation } from '@weve/ui'

import { useViewer } from '@/use'

export default defineComponent({
  name: 'AppNavigation',
  components: {
    WeveNavigation,
  },
  setup() {
    const { viewer } = useViewer()
    return { viewer }
  },
})
